import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { KeyFilterModule } from 'primeng/keyfilter';

@Component({
  selector: 'time-picker',
  templateUrl: './time-picker.component.html',
  standalone: true,
  imports: [
    FormsModule,
    KeyFilterModule
  ]
})
export class TimePickerComponent implements OnInit {
  constructor(
    private commonUtilsService: CommonUtilsService
  ) { }

  @Input() hours: any = null;
  @Input() minutes: any = null;
  @Input() field: any = null;
  @Output() changeTime = new EventEmitter();

  timePicker: any = {
    id: this.commonUtilsService.createId(),
    type: 'date',
    showButton: false,
    hoursPicker: '',//'00'
    minutesPicker: '',//'00'
  }

  ngOnInit(): void {
    let that = this.timePicker;
    that.hoursPicker = this.hours?this.toTime(this.hours):'00';
    that.minutesPicker = this.minutes?this.toTime(this.minutes):'00';
  }

  changeInField(type: any, e:any = null) {
    if(!isNaN(parseInt(e.key))){
      this.validateTime(type);
      let validTime = this.timePicker.hoursPicker && this.timePicker.minutesPicker && this.timePicker.hoursPicker >= 0 && this.timePicker.hoursPicker <= 23 && this.timePicker.minutesPicker >= 0 && this.timePicker.minutesPicker <= 59;
      if(validTime){
        this.emitValue();
      }
    }
  }

  validateTime(type: any = 'hours'){
    let typePicker : any = parseInt(this.timePicker[type + 'Picker']);
    if(type === 'hours' && (typePicker > 2 || this.timePicker[type + 'Picker'].length === 2)){
      this.timePicker.hoursPicker = typePicker < 9? '0' + typePicker : typePicker > 23 ? 23 : this.timePicker.hoursPicker;
      let inputMinute: any = document.getElementById('time-picker-minutes-' + this.timePicker.id);
      this.timePicker.validatedTime = true;
      inputMinute.focus();
      inputMinute.select();
    }else if(type === 'minutes' && (typePicker > 5 || this.timePicker[type + 'Picker'].length === 2)){
      this.timePicker.minutesPicker = typePicker < 9? '0' + typePicker:this.timePicker.minutesPicker;
      this.timePicker.validatedTime = true;
      let inputMinute: any = document.getElementById('time-picker-minutes-' + this.timePicker.id);
      inputMinute.blur();
    }
  }

  blurInputTime(type: any = 'hours'){
    if(!this.timePicker.validatedTime){
      let typePicker : any = parseInt(this.timePicker[type + 'Picker']);
      if(!typePicker){
        this.timePicker[type+'Picker'] = '';
      }
      this.emitValue();
    }else{
      delete this.timePicker.validatedTime;
    }
  }

  emitValue(){
    this.changeTime.emit({hours: this.timePicker.hoursPicker, minutes:this.timePicker.minutesPicker});
  }

  incrementOrDecrement(type: any, direction:any){
    let maxTime: any = type === 'hours'?23:59;
    if(direction === 'decrement' && parseInt(this.timePicker[type+'Picker']) === 0){
      this.timePicker[type+'Picker'] = maxTime;
    }else if((direction === 'increment' && this.timePicker[type+'Picker'] === maxTime) || (direction === 'decrement' && this.timePicker[type+'Picker'] === 1)){
      this.timePicker[type+'Picker'] = '00';
    }else if(direction === 'increment'){
      this.timePicker[type+'Picker']++;
    }else if(direction === 'decrement'){
      this.timePicker[type+'Picker']--;
    }
    this.timePicker[type+'Picker'] = this.toTime(this.timePicker[type+'Picker']);
    this.emitValue();
  }

  toTime(item:any){
    return parseInt(item)<10 && item.length !== 2? '0'+item : item;
  }
}
